"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _CompanyItem = _interopRequireDefault(require("./CompanyItem"));
var _RoleItem = _interopRequireDefault(require("./RoleItem"));
var _UserItem = _interopRequireDefault(require("./UserItem"));
var _utils = require("../utils");
/**
 * [Model] TransmittalItem
 */
var TransmittalItem = exports["default"] = /*#__PURE__*/function () {
  function TransmittalItem() {
    (0, _classCallCheck2["default"])(this, TransmittalItem);
  }
  return (0, _createClass2["default"])(TransmittalItem, null, [{
    key: "parseV2",
    value:
    /**
     * Parse camel case data
     */
    function parseV2(data) {
      var rowData = data || {};
      var entity = new TransmittalItem();
      entity.aggregateModelCount = rowData.aggregateModelCount;
      entity.createdAt = _utils.DateUtil.dateStringReformat(rowData.createdAt);
      entity.createdTime = _utils.DateUtil.dateStringReformat(rowData.createdTime);
      entity.displayRecipients = rowData.displayRecipients;
      entity.documentsCount = rowData.documentsCount;
      entity.download = rowData.download || {};
      entity.fdxFilesCount = rowData.fdxFilesCount;
      entity.folders = (rowData.folders || []).map(_utils.FolderUtil.localizeFolderPath);
      entity.id = rowData.id;
      entity.isCompanyCentric = rowData.isCompanyCentric;
      entity.message = rowData.message;
      entity.receivedTime = _utils.DateUtil.dateStringReformat(rowData.receivedTime);
      entity.recipientViewedTime = rowData.recipientViewedTime;
      entity.recipients = {
        users: _utils.CommonUtil.getValue(rowData, 'recipients.users', []).map(_UserItem["default"].parseV2),
        companies: _utils.CommonUtil.getValue(rowData, 'recipients.companies', []).map(_CompanyItem["default"].parseV2),
        roles: _utils.CommonUtil.getValue(rowData, 'recipients.roles', []).map(_RoleItem["default"].parseV2)
      };
      entity.recipientsCompanies = _utils.CommonUtil.getValue(rowData, 'recipients.recipientsCompanies', []);
      entity.recipientsStatus = rowData.recipientsStatus;
      entity.sentBy = _UserItem["default"].parseV2(rowData.sentBy);
      entity.sequenceId = rowData.sequenceId;
      entity.status = rowData.status;
      entity.title = rowData.title;
      return entity;
    }
  }]);
}();